// Klein weericoon + temperatuur in de draaidag-pil; bij een regenalert een paraplu.
// Rust: geen extra kleurvlak in de pil — icoon en cijfer in de tekstkleur van de pil; alleen
// de paraplu krijgt nadruk (vet). De uitleg (mm, plaats, "locatie onbekend") staat in de tooltip.
import React from 'react';
import { Box } from '@mui/material';
import { weerOmschrijving } from '../../utils/draaidagWeer';

const ICOON = {
  zon: 'sunny', halfbewolkt: 'partly_cloudy_day', bewolkt: 'cloud', mist: 'foggy',
  regen: 'rainy', sneeuw: 'weather_snowy', onweer: 'thunderstorm',
};

const Symbool = ({ name, sx }) => (
  <Box component="span" className="material-symbols-outlined" aria-hidden
    sx={{ fontSize: 14, lineHeight: 1, fontVariationSettings: "'FILL' 0, 'wght' 400", ...sx }}>{name}</Box>
);

export function WeerChip({ weer }) {
  if (!weer) return null;
  const icoon = weer.regen ? 'umbrella' : (ICOON[weer.soort] || 'cloud');
  return (
    <Box component="span" data-testid="weer-chip" aria-label={weerOmschrijving(weer)}
      sx={{ display: 'inline-flex', alignItems: 'center', gap: '2px', flexShrink: 0, ml: 'auto', pl: '4px',
        fontSize: '0.72rem', lineHeight: 1.3, opacity: weer.regen ? 1 : 0.8, fontWeight: weer.regen ? 700 : 500, whiteSpace: 'nowrap' }}>
      <Symbool name={icoon} sx={weer.regen ? { fontVariationSettings: "'FILL' 1, 'wght' 500" } : undefined} />
      {weer.temp_max}°
    </Box>
  );
}

/** Regel voor de tooltip-kaart. */
export function WeerRegel({ weer }) {
  if (!weer) return null;
  return (
    <Box data-testid="weer-regel" sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.75, mt: 0.75,
      fontFamily: '"Inter", system-ui, sans-serif', fontSize: '0.75rem', color: weer.regen ? '#8a5a1f' : '#556071' }}>
      <Symbool name={weer.regen ? 'umbrella' : (ICOON[weer.soort] || 'cloud')} sx={{ color: weer.regen ? '#d4943a' : '#adb3b5', mt: '1px' }} />
      <span>{weerOmschrijving(weer)} <Box component="span" sx={{ color: '#adb3b5' }}>· MET Norway</Box></span>
    </Box>
  );
}
